import React from 'react';
import { Card } from '../../components/ui/Card';
import { DjayNarrator } from '../../mascot';
import { getMasteryBand } from './masteryBands';
import { getBenchmarkContext } from './benchmarkUtils';
interface SubjectsSummaryHeroProps {
  variant: 'parent' | 'teacher';
  // Parent props
  childName?: string;
  overallMastery?: number;
  groupNum?: number;
  topSubject?: string;
  growthSubject?: string;
  // Teacher props
  studentCount?: number;
  classAverage?: number;
  attentionCount?: number;
  onAttentionClick?: () => void;
}
export function SubjectsSummaryHero({
  variant,
  childName,
  overallMastery = 0,
  groupNum = 1,
  topSubject,
  growthSubject,
  studentCount = 0,
  classAverage = 0,
  attentionCount = 0,
  onAttentionClick
}: SubjectsSummaryHeroProps) {
  if (variant === 'parent') {
    const band = getMasteryBand(overallMastery);
    const benchmark = getBenchmarkContext(overallMastery, groupNum);
    const narrative = (() => {
      switch (band.band) {
        case 'strong':
          return `${childName} doet het sterk — gemiddeld ${overallMastery}%.`;
        case 'solid':
          return `${childName} is goed op weg — gemiddeld ${overallMastery}%.`;
        case 'developing':
          return `${childName} groeit door — gemiddeld ${overallMastery}%.`;
        case 'attention':
          return `${childName} heeft hier wat extra aandacht nodig — gemiddeld ${overallMastery}%.`;
      }
    })();
    return <Card className="flex flex-col sm:flex-row items-center gap-4 bg-emerald-600 p-5 border-emerald-700 shadow-sm text-white" data-id="element-8584">
        <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center border border-white/20 flex-shrink-0" data-id="element-8585">
          <DjayNarrator size="sm" emotion="proud" data-id="element-8586" />
        </div>
        <div className="flex-1 text-center sm:text-left" data-id="element-8587">
          <p className="text-emerald-50 font-medium leading-relaxed text-sm sm:text-base" data-id="element-8588">
            {narrative}
            {topSubject && ` Vooral ${topSubject.toLowerCase()} gaat sterk;`}
            {growthSubject && ` ${growthSubject.toLowerCase()} kan nog groeien.`}
          </p>
          <div className="inline-flex items-center gap-1.5 mt-3 px-2.5 py-1 rounded-lg bg-white/10 border border-white/20 text-xs font-bold text-white" data-id="element-8589">
            <span data-id="element-8590">{benchmark.emoji}</span>
            <span data-id="element-8591">{benchmark.description}</span>
          </div>
        </div>
      </Card>;
  }
  // Teacher variant
  return <div className="flex flex-wrap gap-3" data-id="element-8592">
      <Card className="flex-1 min-w-[140px] p-4 bg-white border-slate-200 shadow-sm flex flex-col justify-center" data-id="element-8593">
        <div className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-8594">
          Leerlingen
        </div>
        <div className="text-2xl font-black text-slate-900" data-id="element-8595">{studentCount}</div>
      </Card>
      <Card className="flex-1 min-w-[140px] p-4 bg-white border-slate-200 shadow-sm flex flex-col justify-center" data-id="element-8596">
        <div className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-8597">
          Klasgemiddelde
        </div>
        <div className="text-2xl font-black text-slate-900" data-id="element-8598">
          {classAverage}%
        </div>
      </Card>
      <Card role={attentionCount > 0 ? 'button' : undefined} onClick={attentionCount > 0 ? onAttentionClick : undefined} className={`flex-1 min-w-[140px] p-4 shadow-sm flex flex-col justify-center transition-colors ${attentionCount > 0 ? 'bg-rose-50 border-rose-200 cursor-pointer hover:bg-rose-100' : 'bg-white border-slate-200'}`} data-id="element-8599">
        <div className={`text-xs font-bold uppercase tracking-wider mb-1 ${attentionCount > 0 ? 'text-rose-600' : 'text-slate-500'}`} data-id="element-8600">
          Aandacht Vakken
        </div>
        <div className={`text-2xl font-black ${attentionCount > 0 ? 'text-rose-700' : 'text-slate-900'}`} data-id="element-8601">
          {attentionCount}
        </div>
      </Card>
    </div>;
}